<template>
  <meu-painel>
    <div class="header">
      <h2>Bem vindo {{this.user.username}}</h2>
      <v-btn color="secondary" @click="sair()">Sair</v-btn>
    </div>
    <br />
    <br />
    <div class="centralizado">
      <br />
      <v-bottom-navigation v-model="activeBtn" color="primary">
        <v-btn @click="limpar()">
          <span>Pessoa fisica</span>
        </v-btn>

        <v-btn @click="limpar()">
          <span>Pessoa juridica</span>
        </v-btn>
      </v-bottom-navigation>
      <br />
      <br />
      <form @submit.prevent="cadastroProdutor()">
        <v-text-field
          :label="activeBtn === 0 ? 'Nome' : 'Razão Social'"
          v-model="produtor.name"
          required
        ></v-text-field>
        <v-text-field
          :maxlength="activeBtn === 0 ? '14' : '18'"
          v-mask="[maskCPF, maskCNPJ]"
          :label="activeBtn === 0 ? 'CPF' : 'CNPJ'"
          v-model="produtor.tax_id"
          required
        ></v-text-field>
        <br />

        <v-btn color="primary" type="submit">Gerar Link</v-btn>
      </form>
      <br />
      <router-link :to="{name: 'listagemProdutor'}">
        <v-btn color="primary">Produtores Cadastrados</v-btn>
      </router-link>
      <br />
      <br />
        
      <div class="d-flex align-baseline" v-if="!!url">
        <v-text-field readonly :value="url"></v-text-field>
        <p class="pr-5"></p>
        <v-btn color="primary" type="button" 
          v-clipboard:copy="url"
          v-clipboard:success="() => {
              this.btnCopiar = 'Copiado'
          }"
          v-clipboard:error="() => {
            alert('Não foi possível copiar a url')
          }">{{btnCopiar}}</v-btn>
      </div>

    </div>
  </meu-painel>
</template>


<script>
import Painel from "../../components/Painel.vue";
import api from "../../services/api";
import { mask } from "vue-the-mask";

export default {
  directives: {
    mask
  },
  
  data() {
    return {
      btnCopiar: "Copiar url",
      maskCPF: "###.###.###-##",
      maskCNPJ: "##.###.###/####-##",
      activeBtn: "",
      user: "",
      produtor: {
        name: "",
        tax_id: "",
        document: ""
      },
      url: ""
    };
  },
  components: {
    "meu-painel": Painel
  },
  mounted() {
    const usuario = localStorage.getItem("usuario");
    const auth = localStorage.getItem("token");

    if (!localStorage.getItem("usuario") && !localStorage.getItem("token")) {
      this.$router.push({ name: "login" });
    }

    this.user = JSON.parse(usuario);
    api.defaults.headers.Authorization = `Bearer ${JSON.parse(auth)}`;
  },
  methods: {
    cadastroProdutor() {
      this.produtor.tax_id = this.produtor.tax_id
        .replace(/\./g, "")
        .replace("-", "")
        .replace("/", "");
      this.produtor.document = this.activeBtn === 0 ? "CPF" : "CNPJ";
      api
        .post("/clients", this.produtor)
        .then(response => {
          this.url = response.data.url;
          this.btnCopiar = "Copiar url";
        })
        .catch(err => {
          console.log(err.response.data.error);
          alert(err.response.data.error);
        });
    },

    sair() {
      localStorage.removeItem("usuario");
      localStorage.removeItem("token");
      this.$router.push({ name: "login" });
    },
    limpar() {
      this.produtor.name = "";
      this.produtor.tax_id = "";
    }
  }
};
</script>


<style>
.centralizado {
  text-align: center;
}
.header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}


</style>